'use strict';

angular.module('webAgro1App').directive('informacaoCultivar',function(InformacoesCultivaresService) {
  return {
    templateUrl: 'views/directives/informacao_cultivar.html',
    restrict: 'AE',
    scope: {
      safra: '=',
      gleba: '=',
      insumo: '='
    },
    link: function (scope) {
      scope.$watchGroup(['safra', 'gleba', 'insumo'], function(newValues, oldValues, scope) {
        scope.informacaoCultivar = {};
        if (scope.safra && scope.gleba && scope.insumo) {
          scope.informacaoCultivar.loading = true;

          var params = {
            safra: scope.safra,
            gleba: scope.gleba,
            cd_insumo: scope.insumo,
            tp_insumo: 1
          };

          InformacoesCultivaresService.get(params).then(function(result) {
            scope.informacaoCultivar.dados = result.data[0] || {};
          }).finally(function() {
            scope.informacaoCultivar.loading = false;
          });
        }
      });
    }
  };
});
